import { Utils } from '../../../../utils/common'
import { logger } from '../../../../utils/common/logger'
import { IdentityEvent } from '../../../common/events/identity'
import { ISubscriberServiceAdapter } from '../adapter'
import { LoginService } from '../loginradius/services/login-service'
import { IdentityFormUtils } from './form-utils'

export class VerifyAddressForm {
    private static DOM = {
        class: {
            verifyDeliveryAddressSuccess: 'page-verify-delivery-address-success'
        },
        form: 'verifyDeliveryAddressForm'
    }

    constructor(private pianoAdapter: ISubscriberServiceAdapter) {
    }

    /**
     * Listens for form validated event
     */
    public async init() {
        logger('debug', 'Initializing verify address form')
        const verifyAddressForm = document.querySelector(`[data-id-form=${VerifyAddressForm.DOM.form}]`)

        if (verifyAddressForm) {
            document.addEventListener(IdentityEvent.FORM_VALIDATED,
                async (event: CustomEvent) => {
                    const formType = event.detail.form
                    if (formType === VerifyAddressForm.DOM.form) {
                        await this.submitForm()
                    }
                }
            )
        }

        const successPage = document.querySelector(`.${VerifyAddressForm.DOM.class.verifyDeliveryAddressSuccess}`)

        if (successPage) {
            // refresh subscriber resource and term ids
            document.dispatchEvent(Utils.event(IdentityEvent.IDENTITY_CHANGE, {
                conversions: undefined,
                subscriptions: undefined
            }))
            logger('debug', 'Subscriber resource and term ids refreshed')
        }
        logger('debug', 'Verify address form initialized')
    }

    /**
     * Calls Login Radius update API and adds the print subscription term
     */
    public async submitForm() {
        const formData = IdentityFormUtils.getFields()
        LoginService.clearErrors()

        try {
            // call Piano add print subscription term API
            await this.pianoAdapter.addPrintSubscriptionTerm(formData)

            // send form submission event
            LoginService.sendFormSubmissionEvent('verify-delivery-address')

            // redirect to success page
            location.assign('/verify-delivery-address-success')
        } catch (e) {
            LoginService.showErrors([{
                Description: 'We are unable to verify your delivery address. Please try again later.',
                ErrorCode: 400
            }])
        }
    }
}
